var map = {
	"./baac.svg": 609,
	"./bay.svg": 610,
	"./bbl.svg": 611,
	"./bnp.svg": 612,
	"./boa.svg": 613,
	"./cacib.svg": 614,
	"./cimb.svg": 615,
	"./citi.svg": 616,
	"./db.svg": 617,
	"./ghb.svg": 618,
	"./gsb.svg": 619,
	"./hsbc.svg": 620,
	"./ibank.svg": 621,
	"./icbc.svg": 622,
	"./jpm.svg": 623,
	"./kbank.svg": 624,
	"./kk.svg": 625,
	"./ktb.svg": 626,
	"./lhb.svg": 627,
	"./mb.svg": 628,
	"./mega.svg": 629,
	"./mufg.svg": 630,
	"./rbs.svg": 631,
	"./sc.svg": 632,
	"./scb.svg": 633,
	"./smbc.svg": 634,
	"./tbank.svg": 635,
	"./tcrb.svg": 636,
	"./tisco.svg": 637,
	"./tmb.svg": 638,
	"./uob.svg": 639
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thaibank ^\.\/.*\.svg$
// module id = 75
// module chunks = 1